// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MondooIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 69 35">
    <path d="M51.6 0v34.4a17.2 17.2 0 1 0 0-34.4" />
    <path d="M34.4 34.4a17.2 17.2 0 1 0 0-34.4 17.2 17.2 0 0 0 0 34.4" />
    <path d="M0 17.2c0 9.5 7.7 17.2 17.2 17.2V0C7.7 0 0 7.7 0 17.2" />
  </svg>,
  "Mondoo",
);
export default MondooIcon;
